// @ts-nocheck

import { createSelector } from 'reselect';

import {
  selectBasketIsMonopolyActive,
  selectBasketItemsEntityIsMonopolyActive,
  selectBasketItemsEntityStatus,
  selectBasketMode,
  selectBasketStatus,
} from '../../../../selectors/basket/basketPrimary.selector';
import { selectRuntimeLicence } from '../../../../selectors/runtime/runtimePrimary.selector';
import { BasketModes, BasketStatuses } from '../../../../types/basket';
import { MPSmallCardIconImgPaths, MPFamilies } from '../../constants/families';
import { MPCardTypes } from '../../types/cards';
import { MPFamilyIds } from '../../types/families';
import { selectMPBasketCardFamilyId, selectMPBasketCardIndex } from '../computed/basket';
import { selectIsMPEnabled } from '../computed/runtime';
import { selectIsMPUserOptIn } from '../user';

const getOddIdFromProps = (_, { oddId, oddsId }) => oddId ?? oddsId;

const MPBasketBetslipBandSelectors = {};

MPBasketBetslipBandSelectors.selectCardIconImgPath = createSelector(
  [selectMPBasketCardFamilyId, selectMPBasketCardIndex],
  (familyId, index) => {
    let iconId = familyId;

    if (familyId === MPFamilyIds.ENERGY) {
      iconId = index === 1 ? MPCardTypes.ELECTRICITY : MPCardTypes.WATER;
    }

    return MPSmallCardIconImgPaths[iconId];
  },
);

MPBasketBetslipBandSelectors.selectCardName = createSelector(
  [selectMPBasketCardFamilyId, selectMPBasketCardIndex, selectRuntimeLicence],
  (familyId, index, licence) => MPFamilies[familyId]?.[index - 1]?.name?.[licence],
);

MPBasketBetslipBandSelectors.selectIsVisible = createSelector(
  [
    getOddIdFromProps,
    selectBasketStatus,
    selectBasketMode,
    selectBasketItemsEntityStatus,
    selectBasketIsMonopolyActive,
    selectBasketItemsEntityIsMonopolyActive,
    selectIsMPEnabled,
    selectIsMPUserOptIn,
  ],
  (
    oddsId,
    basketStatus,
    basketMode,
    basketItemStatus,
    basketIsMonopolyActive,
    basketItemIsMonopolyActive,
    isMPEnabled,
    isUserOptIn,
  ) => {
    if (isMPEnabled && isUserOptIn) {
      if (basketMode === BasketModes.SIMPLE && basketItemStatus === BasketStatuses.VALIDATED) {
        return oddsId && basketItemIsMonopolyActive;
      }

      if (basketMode === BasketModes.COMBINED && basketStatus === BasketStatuses.VALIDATED) {
        return !oddsId && basketIsMonopolyActive;
      }
    }

    return false;
  },
);

export default MPBasketBetslipBandSelectors;
